import appTags from "../../views/appSettings/tags.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "tags";
  const params = ["page", "limit"];

  $stateProvider.state("tags", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appTags,
      },
    },
    reloadOnSearch: false,
    data: { title: "Tags" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/tags/tags.urls.js